import {
  THEME_PREF_KEY, normalizePref, resolveTheme, applyResolvedTheme,
} from '@/util/theme';

function readStoredPref() {
  try {
    return normalizePref(window.localStorage.getItem(THEME_PREF_KEY));
  } catch (error) {
    return 'light';
  }
}

function osPrefersDark() {
  return !!(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
}

const initialPref = readStoredPref();

export default {
  namespaced: true,
  state: {
    pref: initialPref,
    resolved: resolveTheme(initialPref, osPrefersDark()),
  },
  getters: {
    pref: (state) => state.pref,
    resolved: (state) => state.resolved,
    isDark: (state) => state.resolved === 'dark',
  },
  mutations: {
    SET_PREF(state, pref) {
      state.pref = pref;
    },
    SET_RESOLVED(state, theme) {
      state.resolved = theme;
    },
  },
  actions: {
    setPref({ commit }, pref) {
      const next = normalizePref(pref);
      try {
        window.localStorage.setItem(THEME_PREF_KEY, next);
      } catch (error) { /* mode privat */ }
      const resolved = resolveTheme(next, osPrefersDark());
      commit('SET_PREF', next);
      commit('SET_RESOLVED', resolved);
      applyResolvedTheme(resolved, document.documentElement);
      return resolved;
    },

    // dipanggil listener OS di main.js, cuma ngaruh kalau prefnya 'system'
    syncOs({ commit, state }, osDark) {
      if (state.pref !== 'system') return state.resolved;
      const resolved = resolveTheme(state.pref, osDark);
      commit('SET_RESOLVED', resolved);
      applyResolvedTheme(resolved, document.documentElement);
      return resolved;
    },
  },
};
